export default function deleteFile(data) {
    const [fileId] = this.dataGet(data.way + '/value').split('::');

    this.saveField({
        way: data.way,
        name: data.name,
        type: 'file',
        value: {
            file: {
                deleteFile: true,
                id: fileId,
            },
        },
    });
    this.route();
}
